var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3787_2893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 3H3.5C1.84297 3 0.5 4.34297 0.5 6V18C0.5 19.657 1.84297 21 3.5 21H21.5C23.157 21 24.5 19.657 24.5 18V6C24.5 4.34297 23.1547 3 21.5 3ZM3.5 4.5H21.5C22.3269 4.5 23 5.17313 23 6V7.68797L13.85 14.5505C13.0531 15.1467 11.9455 15.1467 11.1486 14.5505L2 7.6875V6C2 5.175 2.67313 4.5 3.5 4.5ZM23 18C23 18.8269 22.3269 19.5 21.5 19.5H3.5C2.67313 19.5 2 18.8269 2 18V9.52031L10.25 15.75C10.9119 16.2473 11.7059 16.5009 12.5 16.5009C13.2941 16.5009 14.0891 16.2469 14.75 15.75L23 9.52031V18Z",
    fill: "#354740"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3787_2893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.ed5b3fa432c4eef2112fbc2e88632eeb.svg";
export { ForwardRef as ReactComponent };